import { Library, Crown, Coins, LogOut, User, Layers, Shield } from "lucide-react";
import { KlyrLogo } from "@/components/MarketingSite";

export const Header = ({ onHome, onOpenLibrary, onOpenSeries, onOpenAdmin, libraryCount, user, onUpgrade, onAccount, onLogout }) => {
  const subscribed = user?.subscription_active;
  const pill = "flex items-center gap-2 font-ui text-sm text-slate-200 border border-gold-500/20 hover:border-gold-400 hover:text-gold-200 rounded-full px-2.5 sm:px-4 py-2 transition-colors";
  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-50 backdrop-blur-md bg-[#050915]/85 border-b border-gold-500/12"
    >
      <div className="max-w-7xl mx-auto px-3 sm:px-8 py-3 flex items-center justify-between gap-2 min-w-0">
        <button data-testid="nav-logo" onClick={onHome} className="flex items-center gap-2.5 group">
          <KlyrLogo className="w-10 h-7 group-hover:opacity-90 transition-opacity" />
          <span className="hidden min-[400px]:inline font-ui font-semibold tracking-[0.18em] text-lg text-gold-100 leading-none">KLYR
            <span className="block text-[9px] tracking-[0.5em] text-gold-400/70 mt-0.5">STUDIO</span>
          </span>
        </button>

        <div className="flex items-center gap-1.5 sm:gap-3 min-w-0">
          {user && user.role !== "admin" && (
            subscribed ? (
              <button
                data-testid="plan-badge"
                onClick={onAccount}
                className="flex items-center gap-1.5 text-[11px] font-ui font-semibold text-gold-200 bg-gold-400/10 border border-gold-400/40 hover:border-gold-300 rounded-full px-3 py-1.5 transition-colors"
              >
                <Crown className="w-3.5 h-3.5" /> Unlimited
              </button>
            ) : (
              <button
                data-testid="upgrade-button"
                onClick={onUpgrade}
                className="flex items-center gap-1.5 whitespace-nowrap text-[11px] font-ui font-semibold text-emerald-300 bg-emerald-500/10 border border-emerald-500/40 hover:border-emerald-400 rounded-full px-3 py-1.5 transition-colors"
              >
                <Coins className="w-3.5 h-3.5" />
                {user.credits > 0
                  ? `${user.credits} credit${user.credits > 1 ? "s" : ""}`
                  : user.previews_left > 0
                  ? `${user.previews_left} free preview${user.previews_left > 1 ? "s" : ""}`
                  : "Upgrade"}
              </button>
            )
          )}

          {user?.role === "admin" && (
            <button data-testid="nav-admin-button" onClick={onOpenAdmin}
              className="flex items-center gap-2 font-ui text-sm text-gold-200 border border-gold-400/40 hover:border-gold-300 rounded-full px-4 py-2 transition-colors">
              <Shield className="w-4 h-4" />
              <span className="hidden sm:inline">Admin</span>
            </button>
          )}

          <button data-testid="nav-series-button" onClick={onOpenSeries} className={pill}>
            <Layers className="w-4 h-4" />
            <span className="hidden sm:inline">Series</span>
          </button>

          <button data-testid="nav-recent-books-button" onClick={onOpenLibrary} className={pill}>
            <Library className="w-4 h-4" />
            <span className="hidden sm:inline">Library</span>
            {libraryCount > 0 && (
              <span className="bg-gold-400 text-navy-900 text-[10px] font-bold rounded-full w-5 h-5 flex items-center justify-center">
                {libraryCount}
              </span>
            )}
          </button>

          {user && (
            <button data-testid="account-button" onClick={onAccount} title="Account & billing" className={pill.replace("gap-2 ", "")}>
              <User className="w-4 h-4" />
            </button>
          )}

          {user && (
            <button
              data-testid="logout-button"
              onClick={onLogout}
              title={user.email}
              className="flex items-center gap-2 font-ui text-sm text-slate-400 border border-gold-500/20 hover:border-red-500/50 hover:text-red-300 rounded-full px-2.5 sm:px-3 py-2 transition-colors"
            >
              <LogOut className="w-4 h-4" />
            </button>
          )}
        </div>
      </div>
    </header>
  );
};
